import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiShield, FiCalendar, FiFileText } = FiIcons;

const CTASection = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-gray-800 to-gray-900 text-white">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            No Dejes tu Bienestar para Mañana
          </h2>
          
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            El mejor momento para invertir en tu mente y tu cuerpo es ahora. Deja de repetir los mismos ciclos. 
            Esta estrategia de bienestar puede ayudarte a transformarte de raíz.
          </p>
          
          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-white/10 backdrop-blur-sm p-6 rounded-xl flex items-center gap-3"
            >
              <SafeIcon icon={FiCalendar} className="text-yellow-400 text-2xl" />
              <div className="text-left">
                <p className="text-gray-300">Días restantes:</p>
                <p className="text-2xl font-bold text-yellow-400">15</p>
              </div>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-white/10 backdrop-blur-sm p-6 rounded-xl flex items-center gap-3"
            >
              <SafeIcon icon={FiShield} className="text-green-400 text-2xl" />
              <div className="text-left">
                <p className="text-gray-300">Garantía de satisfacción:</p>
                <p className="text-2xl font-bold text-green-400">100%</p>
              </div>
            </motion.div>
          </div>
          
          <div className="space-y-4">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-yellow-400 text-gray-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 transition-colors flex items-center gap-2 mx-auto shadow-lg"
            >
              ¡Inscribirme ahora y asegurar mi cupo!
              <SafeIcon icon={FiArrowRight} className="text-xl" />
            </motion.button>
            
            <motion.a
              whileHover={{ scale: 1.05 }}
              href="#"
              className="text-gray-300 underline hover:text-yellow-400 transition-colors flex items-center gap-2 justify-center"
            >
              <SafeIcon icon={FiFileText} className="text-lg" />
              Ver plan de estudio
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;